/** 切换浏览器或 Cordova WebView 的全屏状态。 */
export async function toggleDocumentFullscreen () {
  const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement
  if (fullscreenElement) {
    const exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen
    if (typeof exitFullscreen !== 'function') throw new Error('当前环境不支持退出全屏')
    await exitFullscreen.call(document)
    if (window.StatusBar && typeof window.StatusBar.show === 'function') window.StatusBar.show()
    return false
  }

  const root = document.documentElement
  const requestFullscreen = root.requestFullscreen || root.webkitRequestFullscreen
  if (typeof requestFullscreen !== 'function') throw new Error('当前环境不支持全屏显示')
  await requestFullscreen.call(root)
  if (window.StatusBar && typeof window.StatusBar.hide === 'function') window.StatusBar.hide()
  return true
}

/** 连接终端默认的 MPT-II 蓝牙小票打印机。 */
export function connectReceiptPrinter () {
  return new Promise((resolve, reject) => {
    const printer = typeof window !== 'undefined' ? window.BTPrinter : null
    if (!printer || typeof printer.connect !== 'function') {
      reject(new Error('打印插件未加载（BTPrinter 不存在）'))
      return
    }

    printer.connect(
      () => {
        if (typeof printer.setEncoding === 'function') printer.setEncoding(() => {}, () => {}, 'GBK')
        resolve()
      },
      error => reject(new Error(`打印机连接失败：${error}`)),
      'MPT-II'
    )
  })
}

/** 检查蓝牙小票打印机是否已建立连接。 */
export function isReceiptPrinterConnected () {
  return new Promise((resolve, reject) => {
    const printer = typeof window !== 'undefined' ? window.BTPrinter : null
    if (!printer || typeof printer.connected !== 'function') {
      reject(new Error('打印插件未加载（BTPrinter 不存在）'))
      return
    }

    printer.connected(
      status => resolve(status === true || String(status).toLowerCase() === 'true'),
      error => reject(new Error(`打印机状态读取失败：${error}`))
    )
  })
}
